import type { TElement } from "@editor/modules/media-lib/types";
import { nanoid } from "@reduxjs/toolkit";
import type { IMediaFile } from "@/shared/types";
import { prepBlurhashUrl } from "@/shared/utils";

interface IProps {
  src: string;
  alt?: string;

  width?: number;
  height?: number;

  shouldUpload?: boolean;
}

export const makeMediaLibLogoElement = ({
  src,
  alt = "Logo",
  width,
  height,
  shouldUpload = true,
}: IProps): TElement => ({
  category: "Images",
  element: "Logo",
  id: nanoid(),
  json: {
    id: nanoid(),
    children: [],
    type: "element",
    settings: {
      src: appendUploadParam(src, shouldUpload),
      alt,
      shadow: "none",
      round: "0",
      width: "35",
      selectedLinkType: "none",
      horizontalAlignment: "center",
      shape: "free",
      name: "Logo",
      metadata: {
        width,
        height,
        scale: 1,
        translateX: 50,
        translateY: 50,
      },
    },
  },
  order: 0,
  previewImage: null,
});

interface ILogoFromFileProps {
  mediaFile: IMediaFile;
  shouldUpload?: boolean;
  alt?: string;
}

export const makeLogoElementFromMediaFile = ({
  mediaFile,
  shouldUpload = false,
  alt,
}: ILogoFromFileProps) => {
  let url = mediaFile.url;
  const hash = mediaFile.metadata?.imageBlurhash;
  if (hash) url = prepBlurhashUrl(url, hash);

  return makeMediaLibLogoElement({
    src: url,
    width: mediaFile.metadata?.width,
    height: mediaFile.metadata?.height,
    shouldUpload: shouldUpload,
    alt,
  });
};

function appendUploadParam(url: string, shouldUpload: boolean) {
  if (!shouldUpload) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}upload=true`;
}
